const feeInPercentage = {
  paypal: 5, // 5 percentage paypal fee in average
};

export const EXTRA_FEE = [feeInPercentage.paypal];
